import { Money } from '../../common/utils';

/** Částka v haléřích → „5 800 Kč" (celé koruny bez „,00"), „4 793,39 Kč" (s haléři). */
export const formatPrice = (minor: number): string => Money.format(minor, minor % 100 === 0 ? 0 : 2);
